import { SelectBoxGroupItemValue } from 'app/components/Controls/SelectBoxGroup/SelectBoxGroup.interface';
import {
  FilterSectionProps,
  SectionFiltersName,
} from 'app/components/MoreResultsFilters/MoreResultsFilters.interfaces';
import {
  FiltersExcessType,
  MoreFiltersTypeEnum,
  FilterAmortizationType,
  FilterRepairType,
  FiltersEnums,
  LabelEnum,
  InsuranceEnum,
  InsuranceTypeEnum,
} from 'app/shared/enums';

export const filtersMapOptionsToValues = new Map<
  | MoreFiltersTypeEnum
  | FiltersExcessType
  | FilterAmortizationType
  | FilterRepairType
  | boolean,
  FiltersEnums | LabelEnum
>([
  [MoreFiltersTypeEnum.Amortization, FiltersEnums.Amortization],
  [MoreFiltersTypeEnum.ExcessType, FiltersEnums.ExcessType],
  [
    MoreFiltersTypeEnum.AssistanceAfterFailure,
    FiltersEnums.AssistanceAfterFailure,
  ],
  [MoreFiltersTypeEnum.FormOfRepair, FiltersEnums.FormOfRepair],
  [MoreFiltersTypeEnum.SubstituteCar, LabelEnum.ReplacementCar],
  [FiltersExcessType.NoExcess, FiltersEnums.NoExcess],
  [FiltersExcessType.ExcessEqual500, FiltersEnums.ExcessEqual500],
  [FiltersExcessType.ExcessMore500, FiltersEnums.ExcessMore500],
  [
    FilterAmortizationType.AmortizationWithDeduction,
    FiltersEnums.AmortizationWithDeduction,
  ],
  [
    FilterAmortizationType.AmortizationWithoutDeduction,
    FiltersEnums.AmortizationWithoutDeduction,
  ],
  [FilterRepairType.Cash, FiltersEnums.FormOfRepairCash],
  [FilterRepairType.NoCashASO, FiltersEnums.FormOfRepairNoCashASO],
  [FilterRepairType.NoCashService, FiltersEnums.FormOfRepairNoCashService],
  [false, LabelEnum.No],
  [true, LabelEnum.Yes],
]);

export const moreFiltersGTMOptions = new Map<MoreFiltersTypeEnum, string>([
  [MoreFiltersTypeEnum.SubstituteCar, 'assistance_samochód_zastępczy'],
  [MoreFiltersTypeEnum.Amortization, 'ac_amortyzacja'],
  [MoreFiltersTypeEnum.AssistanceAfterFailure, 'assistance_po_awarii'],
  [MoreFiltersTypeEnum.ExcessType, 'ac_udział_własny'],
  [MoreFiltersTypeEnum.FormOfRepair, 'ac_forma_naprawy'],
]);

export const getMoreOptionsFilter = (
  isMotor: boolean,
  option: SelectBoxGroupItemValue
): FilterSectionProps => {
  return option === InsuranceTypeEnum.Ac
    ? getFiltersAcSubFilters(isMotor)
    : getFiltersAssistanceSubFilters(isMotor);
};

export const getFiltersAcSubFilters = (isMotor: boolean) => {
  return {
    title: InsuranceEnum.Ac,
    sectionName: SectionFiltersName.AC,
    sections: [
      {
        sectionTitle: FiltersEnums.ExcessType,
        tooltip: FiltersEnums.ExcessTooltip,
        name: MoreFiltersTypeEnum.ExcessType,
        options: [
          {
            title: FiltersEnums.NoExcess,
            value: FiltersExcessType.NoExcess,
          },
          {
            title: FiltersEnums.ExcessEqual500,
            value: FiltersExcessType.ExcessEqual500,
          },
          {
            title: FiltersEnums.ExcessMore500,
            value: FiltersExcessType.ExcessMore500,
          },
        ],
      },
      {
        sectionTitle: FiltersEnums.Amortization,
        tooltip: isMotor
          ? FiltersEnums.AmortizationTooltipMotor
          : FiltersEnums.AmortizationTooltip,
        name: MoreFiltersTypeEnum.Amortization,
        options: [
          {
            title: FiltersEnums.AmortizationWithoutDeduction,
            value: FilterAmortizationType.AmortizationWithoutDeduction,
          },
          {
            title: FiltersEnums.AmortizationWithDeduction,
            value: FilterAmortizationType.AmortizationWithDeduction,
          },
        ],
      },
      {
        sectionTitle: FiltersEnums.FormOfRepair,
        tooltip: isMotor
          ? FiltersEnums.FormOfRepairTooltipMotor
          : FiltersEnums.FormOfRepairTooltip,
        name: MoreFiltersTypeEnum.FormOfRepair,
        options: [
          {
            title: FiltersEnums.FormOfRepairNoCashASO,
            value: FilterRepairType.NoCashASO,
          },
          {
            title: FiltersEnums.FormOfRepairNoCashService,
            value: FilterRepairType.NoCashService,
          },
          {
            title: FiltersEnums.FormOfRepairCash,
            value: FilterRepairType.Cash,
          },
        ],
      },
    ],
  };
};

export const getFiltersAssistanceSubFilters = (isMotor: boolean) => {
  return {
    title: InsuranceEnum.Assistance,
    sectionName: SectionFiltersName.Assistance,
    sections: [
      {
        sectionTitle: FiltersEnums.AssistanceAfterFailure,
        name: MoreFiltersTypeEnum.AssistanceAfterFailure,
        options: [
          {
            title: LabelEnum.Yes,
            value: true,
          },
          {
            title: LabelEnum.No,
            value: false,
          },
        ],
      },
      {
        sectionTitle: isMotor
          ? FiltersEnums.ReplacementVehicle
          : LabelEnum.ReplacementCar,
        name: MoreFiltersTypeEnum.SubstituteCar,
        options: [
          {
            title: LabelEnum.Yes,
            value: true,
          },
          {
            title: LabelEnum.No,
            value: false,
          },
        ],
      },
    ],
  };
};
